import { ApiHostFileSignature } from "@rmp/api-filestorage";
import { Certificate, CertificateMapper } from "@rmp/core/types/storage/certificate";
import { parseISO } from "date-fns";

export interface FileMetaSignature {
	signature: string;
	createdAt: Date;
	certificates: Certificate[];
}

export class FileMetaSignatureMapper {
	static map(source: ApiHostFileSignature): FileMetaSignature {
		return {
			...source,
			createdAt: parseISO(source.createdAt),
			certificates: (source.certificates ?? []).map(x => CertificateMapper.map(x))
		};
	}
}
